import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { ShowPriceInComponent } from './show-price-in.component';

@NgModule({ declarations: [ShowPriceInComponent],
    exports: [ShowPriceInComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ShowPriceInModule {}
